import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  FormControlLabel,
  Switch,
} from '@mui/material';
import { creaStanza } from '../APIs/RoomsAPI';
import { useTranslation } from 'react-i18next';
import { getTenantTranslation } from '../utils/getTenantTranslation';
import { useSnackbar } from '../contexts/SnackBarContext';

const ModalSala = ({ open, onClose, onSuccess }) => {
  const [nome, setNome] = useState('');
  const [is_active, setIs_active] = useState(true)
  const [errSala, setErrSala] = useState(false)
  const { t } = useTranslation()
  const { showSnackbar } = useSnackbar();
  const tenantType = localStorage.getItem('tenantType');


  const handleSubmit = async () => {
    const token = localStorage.getItem('accessToken');
    const tenant = localStorage.getItem('tenantId');
    if (!nome) return;

    setErrSala(false)

    try {
      await creaStanza({ name: nome, active: is_active }, token, tenant);
      window.dispatchEvent(new Event('map-data-changed'));
      if (onSuccess) onSuccess();
      handleClose(); // Chiudi il modale dopo la creazione
    } catch (err) {
      handleAlert("modals_alert.error_createRoom" + err.message, "error");
      setErrSala(true)
    }
  };

  const handleClose = () => {
    setNome('');
    setIs_active(true);
    setErrSala(false)
    onClose();
  };

  function handleAlert(msg, type) {
    showSnackbar(msg, type)
  }

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>{getTenantTranslation(t, tenantType, 'addRoom')}</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          margin="normal"
          label={getTenantTranslation(t, tenantType, "roomName")}
          value={nome}
          onChange={(e) => setNome(e.target.value)}
        />
        <FormControlLabel label={getTenantTranslation(t, tenantType, "active")} control={<Switch checked={is_active} onChange={() => { setIs_active(!is_active) }} />} />
        <Typography color="red">{errSala ? "Nome Sala Già Esistente" : ""}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{getTenantTranslation(t, tenantType, 'cancel')}</Button>
        <Button onClick={handleSubmit} variant="contained" disabled={!nome}>
          {getTenantTranslation(t, tenantType, 'save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalSala;
